import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {ConfigProvider} from "antd";
import {themeConfig} from "./const/ThemeConfig.const";
import locale from 'antd/es/locale/it_IT';
import "./translates/Translate"
import { Provider } from 'react-redux';
import store from "./store/Store";
import { ProgressProvider } from '../src/services/ProgressContext';
import type {Locale} from "antd/es/locale";
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
document.documentElement.lang = "it";
root.render(
 // <React.StrictMode>
      <BrowserRouter>
          <ConfigProvider theme={themeConfig} locale={locale}>
              <Provider store={store}>
                  <ProgressProvider>
                      <App />
                  </ProgressProvider>
              </Provider>
          </ConfigProvider>
      </BrowserRouter>
 // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
